import React from "react";
import Slider from "react-slick";
import tw from "twin.macro";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Styled components
const Container = tw.div`relative`;
const CarouselContainer = tw.div`max-w-screen-xl mx-auto px-8 py-20`;

const SlideContainer = tw.div`px-4`;
const ImageContainer = tw.div`relative overflow-hidden rounded-lg shadow-lg`;
const Image = tw.img`w-full h-64 sm:h-80 object-cover transition-transform duration-300 hover:scale-105`;
const Caption = tw.div`absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent text-white p-4`;
const CaptionTitle = tw.h3`text-lg font-semibold`;
const CaptionDescription = tw.p`text-sm opacity-75 mt-1`;

// Solución 1: Usar styled-components directamente para estilos personalizados
const StyledSlider = styled(Slider)`
  .slick-prev,
  .slick-next {
    z-index: 10;
    width: 24px;
    height: 24px;
    &:before {
      color: #1DA1F2;
      font-size: 24px;
    }
  }
  
  .slick-prev {
    left: 16px;
  }
  
  .slick-next {
    right: 16px;
  }
  
  .slick-dots {
    bottom: 16px;
    
    li button:before {
      color: white;
      opacity: 0.5;
      font-size: 12px;
    }
    
    li.slick-active button:before {
      color: #1DA1F2;
      opacity: 1;
    }
  }
`;

const ImageCarousel = ({ 
  images = [],
  autoplay = true,
  autoplaySpeed = 4000,
  showDots = true,
  showArrows = true,
  slidesToShow = 3,
  className = ""
}) => {
  
  // Configuración del carrusel
  const settings = {
    dots: showDots,
    infinite: true,
    speed: 1000,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    autoplay: autoplay,
    autoplaySpeed: autoplaySpeed,
    arrows: showArrows,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  // Imágenes por defecto si no se proporcionan
  const defaultImages = [
    {
      src: "/images/utiles.png",
      title: "Útiles Escolares",
      description: "Amplia variedad de productos para estudiantes"
    },
    {
      src: "/images/materiales.jpg", 
      title: "Materiales de Oficina",
      description: "Todo lo necesario para tu oficina"
    },
    {
      src: "/images/utiles2.jpg",
      title: "Productos de Calidad",
      description: "Los mejores productos al mejor precio"
    }
  ];

  const carouselImages = images.length > 0 ? images : defaultImages;

  return (
    <Container className={className}>
      <CarouselContainer>        
        <StyledSlider {...settings}>
          {carouselImages.map((image, index) => (
            <SlideContainer key={index}>
              <ImageContainer>
                <Image 
                  src={image.src} 
                  alt={image.title || `Imagen ${index + 1}`}
                  onError={(e) => {
                    e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZGRkIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMTgiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIiBmaWxsPSIjOTk5Ij5JbWFnZW4gbm8gZGlzcG9uaWJsZTwvdGV4dD48L3N2Zz4=';
                  }}
                />
                {(image.title || image.description) && (
                  <Caption>
                    {image.title && <CaptionTitle>{image.title}</CaptionTitle>}
                    {image.description && <CaptionDescription>{image.description}</CaptionDescription>}
                  </Caption>
                )}
              </ImageContainer>
            </SlideContainer>
          ))}
        </StyledSlider>
      </CarouselContainer>
    </Container>
  );
};

export default ImageCarousel;